export default class OneDriveUrl {
  static picker = (baseUrl: string, queryString: string): string => (
    `${ baseUrl }?${ queryString }`
  );

  static getRedirectUrl = () => `${ window.location.origin }/onedrive-redirect`;

  static microsoftAllowedOriginsPattern = /^https:\/\/(onedrive\.live\.com|1drv\.ms|my\.microsoftpersonalcontent\.com|[\w-]+\.sharepoint\.(com|us|de|cn)|[\w-]+\.onedrive\.(com|us|de|cn))$/;

  static consumerScope = ['OneDrive.ReadOnly'];

  static commonScope = ['Files.Read'];

  static microsoftGraphUrl = 'https://graph.microsoft.com/v1.0/me/drive';

  static commonAuthorityUrl = 'https://login.microsoftonline.com/common';

  static consumerAuthorityUrl = 'https://login.microsoftonline.com/consumers';

  static consumerTenantId = '9188040d-6c67-4c5b-b112-36a304b66dad';

  static consumerPickerUrl = 'https://onedrive.live.com/picker';

  static myOrigin = (origin: string) =>
    origin.includes('-my.sharepoint.com')
      ? origin
      : origin.replace('.sharepoint.com', '-my.sharepoint.com');

  static commonPickerUrl = (origin: string) =>
    `${ OneDriveUrl.myOrigin(origin) }/_layouts/15/FilePicker.aspx`;

  static defaultScope = (origin: string) =>
    [`${ OneDriveUrl.myOrigin(origin) }/.default`];

  static itemChildren = (endpoint: string, driveId: string, itemId: string): string =>
    `${ endpoint }/drives/${ driveId }/items/${ itemId }/children`;

  static itemDownloadUrl = (endpoint: string, driveId: string, itemId: string): string =>
    `${ endpoint }/drives/${ driveId }/items/${ itemId }?select=id,@microsoft.graph.downloadUrl`;
}
